export enum VIEWER_TYPE {
  PROCESSING = 'PROCESSING_VIEWER',
  CUSTOMER = 'CUSTOMER',
}

export enum VIEWER_MODE {
  LAYERS_MODE = 'LAYERS_MODE',
  PHOTOS_MODE = 'PHOTOS_MODE',
}
